export function isNode() {
  // Close enough
  return !isBrowser()
}

export function isBrowser() {
  try {
    return !!(window && window.document && window.document.createElement)
  } catch (e) {
    return false
  }
}

export function isAngular1() {
  return !!(isBrowser() && typeof window.angular !== 'undefined' && window.angular.version.major === 1)
}

export function isProduction() {
  if (isBrowser()) {
    return !!(location.protocol.match('http') && !location.host.match(/local|dev|qaa|qab|qac/g))
  } else {
    return process.env.NODE_ENV === 'production'
  }
}

export function isDev() {
  return !isProduction()
}

export function isLocalStorageEnabled() {
  try {
    return !!(typeof window === 'object' && window === window.parent && window.localStorage)
  } catch (e) {
    return false
  }
}
